import { render, staticRenderFns } from "./AppSidebarNavDropdown.vue?vue&type=template&id=77b0fd87&"
import script from "./AppSidebarNavDropdown.vue?vue&type=script&lang=js&"
export * from "./AppSidebarNavDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports